import React from "react";
import vision from "../../images/about/ourvision.png";
import mission from "../../images/about/ourmission.png";
import founder from "../../images/about/founder.jpg";
import founder2 from "../../images/about/founder2.JPG";
import md from "../../images/about/md.jpg";
import mdmam from "../../images/about/MamImage.jpg";
import wideproperty from "../../images/about/wide-selection-property.png";
import esupport from "../../images/about/end-to-end-support.png";
import excellence from "../../images/about/commitment-to-excellence.png";
import ashishharwani from "../../images/team/ashishharwani.jpg";
import rohitgupta from "../../images/team/rohitgupta.jpg";
import mukeshprajapat from "../../images/team/mukeshprajapat.jpg";
import krishankumarsaini from "../../images/team/krishankumarsaini.jpg";
import testBg from "../../images/about/testBg.jpg";
import testimoimg from "../../images/testimoimg.jpg";
import testimoimg2 from "../../images/seller1.jpg";
import quotedUp from "../../images/about/quoted-up.png";
import quotedDown from "../../images/about/quoted-down.png";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import NewTestimonial from "../NewTestimonial";

const NewAbout = () => {
  const teamMembers = [
    {
      name: "Rohit Gupta",
      designation: "Company Head",
      image: rohitgupta, // Replace with your image paths
    },
    {
      name: "Ashish Harwani",
      designation: "General Manager",
      image: ashishharwani,
    },
    {
      name: "Mukesh Prajapat",
      designation: "Director of Sales",
      image: mukeshprajapat,
    },
    {
      name: "Krishan Kumar Saini",
      designation: "Sales Head",
      image: krishankumarsaini,
    },
  ];

  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <button
        className="custom-arrow-show-leadership leadership-next-arrow"
        onClick={onClick}
        aria-label="Next"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 48 48"
          fill="none"
          stroke="gray"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ marginLeft: "-20px", marginTop: "-3px" }}
        >
          <line x1="6" y1="24" x2="40" y2="24" />
          <polyline points="30 14 40 24 30 34" />
        </svg>
      </button>
    );
  };

  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <button
        className="custom-arrow-show-leadership leadership-prev-arrow"
        onClick={onClick}
        aria-label="Previous"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 48 48"
          fill="none"
          stroke="gray"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ marginLeft: "3px", marginTop: "-3px" }}
        >
          <line x1="42" y1="24" x2="8" y2="24" />
          <polyline points="18 14 8 24 18 34" />
        </svg>
      </button>
    );
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000, // 1 second = 1000ms
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          nextArrow: <NextArrow />,
          prevArrow: <PrevArrow />,
        },
      },
    ],
  };

  const testimonials = [
    {
      name: "Mrs. Preeti",
      description:
        "I'm impressed with the level of service and dedication shown by the Siddhiananta Group. They helped me navigate the complexities of buying an investment plot with ease.",
      image: testimoimg,
    },
    {
      name: "Mrs. Ankita ",
      description:
        "From the initial consultation to the closing, Siddhiananta Group provided exceptional support.They truly care about their clients' needs and deliver on their promises.",
      image: testimoimg2,
    },
    // Add more testimonials here...
  ];
  const settings1 = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <>
      <section className="new-about-section mb-5">
        <div className="new-overlay"></div>
        <div
          className="container"
          style={{ position: "inherit", zIndex: 99, margin: "90px auto" }}
        >
          <div className="d-flex align-items-center gap-3">
            <p className="about-text mb-0">About US</p>
            <div className="horizontal-line"></div>
          </div>
          <div className="about-description mt-4">
            <p>
              <strong>सपने आपके, शुरुआत हमारी</strong> — Siddhi Ananta Group
              stands as a trusted and distinguished name in Jaipur’s real estate
              sector, renowned for delivering excellence with integrity,
              transparency, and unmatched customer satisfaction. We specialize
              in premium residential and commercial plots that cater to the
              modern lifestyle needs of homeowners and the investment goals of
              visionary buyers. With an exclusive focus on Jaipur Development
              Authority (JDA) approved properties, every plot we offer ensures
              complete legal assurance, long-term security, and high future
              value.
            </p>

            <p>
              Our deep expertise in Jaipur’s rapidly expanding real estate
              landscape enables us to identify prime and growth-ready locations
              — ideal for personal living or commercial development. At Siddhi
              Ananta Group, property buying becomes a seamless, transparent, and
              fulfilling journey. From initial consultation to final possession,
              we stand beside our clients at every step, transforming their
              aspirations into a proud reality. Committed to professionalism and
              a customer-first approach, we continue to set new benchmarks by
              helping clients make informed, confident, and future-ready
              investment decisions.
            </p>
          </div>
          <div className="row justify-content-between mt-5 ">
            <div className="our-vision-content col-md-5 p-4">
              <img src={vision} />
              <p className="mb-0">
                Our vision is to make Siddhi Ananta Group a leading and trusted
                name in the real estate industry, where every individual can
                find their dream property and the best investment opportunities.
                We envision a future characterized by transparency, innovation,
                and long-term appreciation in every aspect of real estate.
              </p>
              <p className="mb-0">
                Our goal is not only to achieve business success but also to
                contribute to sustainable development and prosperity across all
                sectors of society. We are committed to fulfilling our
                responsibility toward society and the environment through every
                project we undertake.
              </p>
            </div>
            <div className="our-mission-content col-md-5 p-4">
              <img src={mission} />
              <p className="mb-0">
                Our mission is to provide our clients with the best real estate
                services that not only meet their current needs but also lay a
                strong foundation for their future.
              </p>
              <p className="mb-0">
                We offer excellent solutions in residential, commercial, and
                investment properties, working with quality, transparency, and
                integrity. Our aim is not just to facilitate property
                transactions but to build long-term relationships with our
                clients, ensuring their investments are safe and profitable.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="new-founder-section mb-5">
        <div className="container">
          <div className="founder-detail-section">
            <div className="image-section">
              <img className="founder-image" src={founder2} />
              <p className="md-name">Rajendra Singh Chauhan</p>
            </div>
            <div>
              <div className="founder-detail-header">
                <div className="horizontal-line-mob mob"></div>
                <h6 className="mb-0 company-name-text">
                  <span className="founder-text">Founder & CEO</span>
                  <span className="desk">,</span> Siddhi Ananta Group
                </h6>{" "}
                <div className="horizontal-line desk"></div>
              </div>
              {/* <p className="founder-description mt-4">
                {" "}
                Founder Siddhi Ananta Group was founded on a simple but powerful
                idea – every person deserves a home that is not only beautiful
                and safe, but also a reflection of their life dreams. When we
                started this journey, my aim was not just to build buildings,
                but to create a living experience for people that improves their
                lives today and in the future. I firmly believe that the
                property business is not just a business; it is a business of
                trust.
              </p>
              <p className="founder-description">
                Our customer satisfaction is our biggest asset. This is why we
                have established ourselves as a reliable and responsible company
                that believes in timely delivery, transparency, and respecting
                customer wishes. At Siddhi Ananta Group, we build not just for
                today, but for the future as well. We are committed to breaking
                new ground with our values of trust, honesty, and the highest
                quality.
              </p>
              <p className="founder-description">
                I thank you from the bottom of my heart for being a part of the
                Siddhi Ananta Group family. Without your trust, this journey
                would not have been possible.
              </p> */}
              <p className="founder-description mt-4">
                <strong>सपने आपके, शुरुआत हमारी</strong> — This is the belief
                that laid the foundation of Siddhi Ananta Group under the
                leadership of our Founder & CEO, <strong>Rajendra Singh Chauhan</strong>. With over{" "}
                <strong>10+ years of experience</strong> in the real estate
                industry, he has been committed to creating properties that are
                not just structures, but dreams turned into reality. His vision
                has always been clear — every family deserves a home that is
                safe, premium, and a reflection of their aspirations.
              </p>

              <p className="founder-description">
                When we started this journey, the goal was never just to develop
                land, but to deliver value and enhance the way people live today
                and in the future. Mr. Chauhan firmly believes that the real
                estate business is not merely a business — it is a{" "}
                <strong>business of trust</strong>. Guided by honesty,
                transparency, and integrity, Siddhi Ananta Group continues to
                build a strong reputation as a trusted name in Jaipur’s property
                market.
              </p>

              <p className="founder-description">
                Customer satisfaction remains our greatest achievement. This is
                why Siddhi Ananta Group is dedicated to timely delivery, legal
                transparency, and respecting every customer’s expectations. We
                build not only for the present, but also with a vision for the
                future — contributing to the growth and development of Jaipur
                while maintaining the highest standards of quality.
              </p>

              <p className="founder-description">
                On behalf of Siddhi Ananta Group, I express immense gratitude to
                every customer who has believed in us. Your trust is our
                strength — and together, we will continue to turn dreams into
                reality.
                <br />
                <strong>सपने आपके, शुरुआत हमारी…</strong>
              </p>
            </div>
          </div>
          <div className="md-detail-section mt-5">
            <div className="image-section">
              <img
                className="md-image"
                style={{ height: "520px" }}
                src={mdmam}
              />
              <p className="md-name">Khushbu Shekhawat</p>
            </div>
            <div>
              <div className="md-detail-header">
                <div className="horizontal-line-mob mob"></div>
                <h6 className="mb-0 company-name-text">
                  <span className="md-text">Managing Director</span>
                  <span className="desk">,</span>Siddhi Ananta Group
                </h6>{" "}
                <div className="horizontal-line desk"></div>
              </div>
              {/* <p className="md-description mt-4">
                {" "}
                I firmly believe that every customer's dream is priceless. For
                us, real estate is not just a medium of business; it is a
                business of trust. It is a strong relationship built on our
                values and principles. Timely delivery, high quality, and
                transparency are the pillars of our work. This belief is what
                makes Siddhi Ananta Group a trusted name in the field of real
                estate.
              </p>
              <p className="md-description">
                Siddhi Ananta Group's journey has been one of continuous
                progress, and we are committed to exploring new dimensions with
                our principles in the future as well. Our vision for the future
                is clear: with innovation, consistency, and excellence, we aim
                to create a real estate brand that people can trust blindly. We
                are grateful for your trust and support and are committed to
                providing you with the best services as we continue this journey
                together.
              </p>
              <p className="md-description">
                I thank you all for your support and trust in Siddhi Ananta
                Group's journey. Your support, combined with our dedication,
                will create a future where your dreams take real shape. We will
                always stand by you on this journey to make your dreams come
                true.
              </p> */}
              <p className="md-description mt-4">
                <strong>सपने आपके, शुरुआत हमारी</strong> — inspired by this
                belief, <strong>Khushbu Shekhawat</strong>, Managing Director of <strong>Siddhi Ananta Group</strong>, has been a driving force
                behind the company’s remarkable growth. With{" "}
                <strong>10+ years of experience</strong> in real estate and
                business leadership, she has played a vital role in developing a
                brand that stands firmly on trust, transparency, and customer
                happiness.
              </p>

              <p className="md-description">
                She believes that every customer’s dream holds immense value,
                and turning that dream into a beautiful reality is the true
                success of <strong>Siddhi Ananta Group</strong>. For her, real
                estate is not merely a commercial sector — it is a{" "}
                <strong>business of trust</strong>, built on ethics, dedication,
                and a long-term relationship with every client.
              </p>

              <p className="md-description">
                Under her leadership, Siddhi Ananta Group continues to achieve
                continuous progress and expansion while maintaining our brand
                principles —
                <strong>innovation, consistency, and excellence</strong>. She
                envisions a future where the company continues to create secure
                and high-value properties that elevate lifestyles and bring
                pride to every homeowner and investor.
              </p>

              <p className="md-description">
                She expresses heartfelt gratitude to every customer and partner
                who has supported this journey. Your faith in Siddhi Ananta
                Group motivates us to deliver the finest experiences — today,
                tomorrow, and always.
                <br />
                <strong>
                  सपने आपके, शुरुआत हमारी… Your dream, our commitment.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </section>
      <section
        className="leadership-section sectionbotgap desk"
        style={{ position: "relative", marginTop: "140px" }}
      >
        <div className="container">
          <div className="d-flex align-items-center gap-3 mb-4">
            <p className="leadership-text mb-0">Our leadership</p>
            <div className="horizontal-line"></div>
          </div>
          <div className="leadership-slider-wrapper">
            <Slider {...settings}>
              {teamMembers.map((member, index) => (
                <div key={index} className="leadership-team-card">
                  <div className="image-wrapper">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="leadership-team-image"
                    />
                    <div className="leadership-overlay">
                      <div style={{ padding: "273px 0px" }}>
                        <h4>{member.name}</h4>
                        <p>{member.designation}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
        <div className="static-count-area">
          <div className="static-count-area-overlay"></div>
          <div className="container">
            <Link to="/team">
              {" "}
              <button className="our-team-button">Meet Our Team</button>
            </Link>

            {/* <div className="leadership-statistics-area">
              <div className="row">
                <div className="col-md-4 col-12">
                  <div className="statisbox">
                    <h1>2700+</h1>

                    <h5>Happy Clients</h5>
                    <p>Over 2700 happy clients and counting.</p>
                  </div>
                </div>

                <div className="col-md-4 col-12">
                  <div className="statisbox">
                    <h1>10+</h1>
                    <h5>Townships Listed</h5>
                    <p>Explore over 10 townships available for sale.</p>
                  </div>
                </div>

                <div className="col-md-4 col-12">
                  <div className="statisbox">
                    <h1>100%</h1>
                    <h5>Customer Satisfaction</h5>
                    <p>Turning buyers into delighted plot owners.</p>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
      <section className="mob">
        <div className="static-count-area">
          <div className="static-count-area-overlay"></div>
          <div
            className="sectiontitle mb-2 mt-2"
            style={{ position: "relative", zIndex: 9 }}
          >
            <div className="titleunderline">
              <svg
                width="64"
                height="3"
                viewBox="0 0 64 3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 1.5H62"
                  stroke="#F68633"
                  stroke-width="3"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <h1 style={{ color: "#FFFFFF", textTransform: "capitalize" }}>
              Our leadership
            </h1>
          </div>
          <div style={{ textAlign: "center" }}>
            <Link to="/team">
              {" "}
              <button className="our-team-button">Meet Our Team</button>
            </Link>
          </div>

          <div className="leadership-slider-wrapper">
            <Slider {...settings}>
              {teamMembers.map((member, index) => (
                <div key={index} className="leadership-team-card">
                  <div className="image-wrapper">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="leadership-team-image"
                    />
                    <div className="leadership-overlay">
                      <div style={{ padding: "273px 0px" }}>
                        <h4>{member.name}</h4>
                        <p>{member.designation}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          {/* <div className="leadership-statistics-area">
            <div className="row">
              <div className="col-md-4 col-12">
                <div className="statisbox">
                  <h1>2700+</h1>

                  <h5>Happy Clients</h5>
                  <p>Over 2700 happy clients and counting.</p>
                </div>
              </div>

              <div className="col-md-4 col-12">
                <div className="statisbox">
                  <h1>10+</h1>
                  <h5>Townships Listed</h5>
                  <p>Explore over 10 townships available for sale.</p>
                </div>
              </div>

              <div className="col-md-4 col-12">
                <div className="statisbox">
                  <h1>100%</h1>
                  <h5>Customer Satisfaction</h5>
                  <p>Turning buyers into delighted plot owners.</p>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </section>
      <section className="expri-section sectiontopgap sectionbotgap">
        <div className="container">
          <div className="sectiontitle mb-3">
            <div className="titleunderline">
              <svg
                width="64"
                height="3"
                viewBox="0 0 64 3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 1.5H62"
                  stroke="#F68633"
                  stroke-width="3"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <h1>
              Experience Luxury, <br class="d-block d-md-none" /> Choose Siddhi
              Ananta Group
            </h1>
          </div>

          <div className="expdata">
            <div className="row">
              <div className="col-md-4 col-12">
                <div className="expcard-out">
                  <img
                    src={wideproperty}
                    alt="wideproperty"
                    className="expcardimg"
                  />
                  <div className="expcard">
                    <h3>Wide Selection of Property</h3>
                    <p>
                      We provide plots for residential, business, and investment
                      purposes, meeting all needs and budgets.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-12">
                <div className="expcard-out expcard2">
                  <img src={esupport} alt="esupport" className="expcardimg" />
                  <div className="expcard">
                    <h3>End-to-End Support</h3>
                    <p>
                      Our dedicated team is here to answer your questions and
                      ensure a smooth transaction.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-12">
                <div className="expcard-out expcard2">
                  <img
                    src={excellence}
                    alt="excellence"
                    className="expcardimg"
                  />
                  <div className="expcard">
                    <h3>Commitment to Excellence</h3>
                    <p>
                      Count on our superior service, whether it's for personal
                      or investment purposes.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="ownership-section sectiontopgap sectionbotgap">
        <div className="container">
          <div className="ownership-header">
            <div className="titleunderline">
              <svg
                width="64"
                height="3"
                viewBox="0 0 64 3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 1.5H62"
                  stroke="#F68633"
                  stroke-width="3"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <h6 className="path-text mt-2">
              Your Pathway to Property Ownership
            </h6>
          </div>
          <div className="path-description mt-4">
            <div className="path-description-section mb-4">
              <p className="path-description-text">Customer-Centricity</p>
              <p className="path-description-value mb-0">
                Siddhi Ananta Group Group prioritizes the needs and satisfaction
                of its customers, ensuring their interests are always at the
                forefront of its operations.
              </p>
            </div>
            <div className="path-description-section mb-4">
              <p className="path-description-text">Transparency</p>
              <p className="path-description-value mb-0">
                The Siddhi Ananta Group is committed to building credibility and
                trust with its clients by having honest, open contact with them.
              </p>
            </div>
            <div className="path-description-section">
              <p className="path-description-text">Integrity</p>
              <p className="path-description-value mb-0">
                Siddhi Ananta Group upholds the highest ethical standards,
                ensuring fairness, honesty, and accountability in all its
                dealings.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="testimonial-section mb-5" style={{ height: "690px" }}>
        <div className="ownership-header">
          <div className="titleunderline">
            <svg
              width="64"
              height="3"
              viewBox="0 0 64 3"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 1.5H62"
                stroke="#F68633"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <h6 className="client-text mt-2">
            Words That Inspire Us — <br class="d-block d-md-none" />
            From Our Esteemed Clients
          </h6>
        </div>
        <div style={{ position: "relative" }} className="mt-5">
          <div className="testimonial-card">
            <Slider {...settings1}>
              {testimonials.map((item, index) => (
                <div
                  style={{ width: "90%", margin: "auto", overflow: "hidden" }}
                >
                  <div className="testimonial-card-top">
                    <div>
                      <img
                        className="testimonial-user-image"
                        src={item.image}
                        alt={item.name}
                      />
                    </div>
                    <div style={{ marginTop: "-13px" }}>
                      <p className="testimonial-user-name mb-0">{item.name}</p>
                      <div>
                        {Array(5)
                          .fill(0)
                          .map((_, i) => (
                            <svg
                              key={i}
                              width="22"
                              height="21"
                              viewBox="0 0 16 17"
                              fill="rgb(255, 213, 0)"
                              xmlns="http://www.w3.org/2000/svg"
                              stroke="rgb(255, 213, 0)"
                            >
                              <path
                                d="M7.51338 3.43946C7.66772 3.09321 7.74492 2.92008 7.85238 2.86677C7.94572 2.82045 8.05532 2.82045 8.14865 2.86677C8.25612 2.92008 8.33332 3.09321 8.48765 3.43946L9.71698 6.19742C9.76265 6.29978 9.78545 6.35096 9.82078 6.39015C9.85198 6.42483 9.89018 6.45257 9.93278 6.47156C9.98098 6.49302 10.0367 6.49891 10.1482 6.51067L13.151 6.8276C13.528 6.86739 13.7165 6.88728 13.8004 6.97301C13.8733 7.04747 13.9072 7.15174 13.892 7.25483C13.8745 7.3735 13.7337 7.50036 13.4521 7.75416L11.209 9.77563C11.1258 9.85063 11.0841 9.88817 11.0578 9.93383C11.0345 9.9743 11.0199 10.0192 11.015 10.0656C11.0095 10.118 11.0211 10.1728 11.0443 10.2825L11.6709 13.2363C11.7495 13.6072 11.7889 13.7926 11.7333 13.8988C11.6849 13.9912 11.5963 14.0556 11.4935 14.073C11.3753 14.093 11.2111 13.9984 10.8827 13.809L8.26698 12.3003C8.16992 12.2443 8.12138 12.2164 8.06978 12.2054C8.02412 12.1957 7.97692 12.1957 7.93125 12.2054C7.87965 12.2164 7.83112 12.2443 7.73405 12.3003L5.1184 13.809C4.79001 13.9984 4.62582 14.093 4.50754 14.073C4.4048 14.0556 4.31611 13.9912 4.26782 13.8988C4.21222 13.7926 4.25155 13.6072 4.33021 13.2363L4.95672 10.2825C4.97997 10.1728 4.9916 10.118 4.98608 10.0656C4.98119 10.0192 4.96661 9.9743 4.94328 9.93383C4.91691 9.88817 4.87528 9.85063 4.79204 9.77563L2.54896 7.75416C2.26735 7.50036 2.12654 7.3735 2.10904 7.25483C2.09384 7.15174 2.12771 7.04747 2.2006 6.97301C2.28452 6.88728 2.47302 6.86739 2.85002 6.8276L5.85288 6.51067C5.96434 6.49891 6.02006 6.49302 6.06824 6.47156C6.11088 6.45257 6.14905 6.42483 6.18029 6.39015C6.21559 6.35096 6.2384 6.29978 6.28404 6.19742L7.51338 3.43946Z"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          ))}
                      </div>
                    </div>
                  </div>
                  <div
                    className=""
                    style={{ height: "175px", position: "relative" }}
                  >
                    <img
                      className=""
                      src={quotedUp}
                      alt="quoted "
                      style={{ position: "absolute", left: "11%" }}
                    />
                    <p className="testimonial-user-description">
                      {item.description.split(" ").slice(0, 25).join(" ")}
                      {item.description.split(" ").length > 25 && "..."}
                    </p>
                    <img
                      className=""
                      src={quotedDown}
                      alt="quoted "
                      style={{
                        position: "absolute",
                        top: "126px",
                        right: "11%",
                      }}
                    />
                  </div>
                </div>
              ))}
            </Slider>
            <div>
              <p className="testimonial-salutaion">
                Thank you for your trust and support Siddhi Ananta Group is
                honored to serve you.
              </p>
            </div>
          </div>
          <div className="testimonial-slider-section desk">
            <img src={testBg} />
          </div>
        </div>
      </section> */}
      <NewTestimonial />
    </>
  );
};

export default NewAbout;
